import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";

import { BtnActions, IconTypeEnum, TableColumnType ,TableColumn} from "../../../common/interfaces/global-interfaces";
import { NotificationService } from "../../../services/notification.service";
import { SettingsService } from "../../../services/settings.service";
import { LayoutService } from "../../../shared/components/app-layout/shared-layout/layout.service";
import { AppState } from "../../../store";
import { StoreItemActions } from "../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../store/entities/store-item/store-item.model";
import { SubscriptionAddComponent } from "../../subscription-management/subscription-add/subscription-add.component";
import { GET_ALL_SUBSCRIPTION, DELETE_SUBSCRIPTION_MUTATION } from "../../subscription-management/subscription.graphql";
import { SubscriptionResponse } from "../../subscription-management/subscription.model";

@Component({
  selector: "app-corporate-subscription",
  templateUrl: "./corporate-subscription.component.html",
  styleUrl: "./corporate-subscription.component.scss",
})
export class CorporateSubscriptionComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly settings = inject(SettingsService);
  private readonly notify = inject(NotificationService);
  private readonly store = inject(Store<AppState>);
  readonly layoutService = inject(LayoutService);

  title = "Subscription List";
  addPermission: string[] = ["NO_PERMISSION"];

  query = GET_ALL_SUBSCRIPTION;
  upsertAction = StoreItemActions.upsertStoreItem;
  deleteAction = StoreItemActions.deleteStoreItem;
  storeEntity: StoreItemEntity = StoreItemEntity.subscription;
  additionalVariables = {
    pageNumber: 0,
  };
  viewDetails = false;
  viewDetailsTitle = "View Subscription";

  tableColumns: TableColumn[] = [];
  tableActions: BtnActions[] = [
    {
      id: "more",
      title: "Actions",
      permissions: ["NO_PERMISSION"],
      icon: "more_horiz",
      iconType: IconTypeEnum.MATERIAL,
      children: [
        {
          id: "view",
          title: "View",
          permissions: ["NO_PERMISSION"],
          icon: "visibility",
          iconType: IconTypeEnum.MATERIAL,
        },
        
      ],
    },
  ];

  ngOnInit(): void {
    this.tableColumns = [
      { keyword: "", title: "SN", type: TableColumnType.index },

      {
        keyword: "userAccount.firstName",
        title: "First Name",
        sortableColumn: "userAccount.firstName",
      },
      {
        keyword: "userAccount.lastName",
        title: "Last Name",
        sortableColumn: "userAccount.lastName",
      },
      {
        keyword: "userAccount.fullName",
        title: "Full Name",
        sortableColumn: "userAccount.fullName",
      },
      {
        keyword: "userAccount.username",
        title: "Username",
        sortableColumn: "userAccount.username",
      },
      {
        keyword: "userAccount.phone",
        title: "Phone",
        sortableColumn: "userAccount.phone",
      },

      {
        keyword: "subscriptionType",
        title: "Subscription Type",
        sortableColumn: "subscriptionType",
      },
      { keyword: "isPaid", title: "Paid Status", sortableColumn: "isPaid" },
      {
        keyword: "startDate",
        title: "Start Date",
        sortableColumn: "startDate",
      },
      { keyword: "endDate", title: "End Date", sortableColumn: "endDate" },

      {
        keyword: "subscriptionItems.0.product.title",
        title: "Product",
        sortableColumn: "subscriptionItems.0.product.title",
      },
      {
        keyword: "subscriptionItems.0.numberDays",
        title: "Number of Days",
        sortableColumn: "subscriptionItems.0.numberDays",
      },
      {
        keyword: "subscriptionItems.0.rateCard.title",
        title: "Rate Card",
        sortableColumn: "subscriptionItems.0.rateCard.title",
      },

      // Action column
      { keyword: "actions", title: "Action", isActionColumn: true },
    ];
  }

  trackByUuid = (_: number, item: SubscriptionResponse) => item.uuid;


  onView(subscription: SubscriptionResponse): void {
  this.router.navigate(['/corporate/subscription', subscription.uuid]);
}


  onAdd(subscription?: SubscriptionResponse): void {
    this.router.navigate(['/subscription'], 
      );
  }

  btnClicked(ev: { id: string; data: SubscriptionResponse }): void {
    if (!ev?.data) return;

    const subscription = ev.data;

    switch (ev.id) {
      case "view":
        this.onView(subscription);
        break;
      case "edit":
        this.onAdd(subscription);
        break;
      case "delete":
        this.onDelete(subscription);
        break;
      default:
        console.warn(`Unhandled action: ${ev.id}`);
    }
  }

  onDelete(subscription: SubscriptionResponse): void {
    this.notify
      .confirmation({
        title: "Delete Subscription",
        message: "Are you sure you want to delete this subscription?",
      })
      .then((confirmed) => {
        if (confirmed) {
          this.store.dispatch(
            StoreItemActions.removeStoreItem({
              entity: this.storeEntity,
              mutation: DELETE_SUBSCRIPTION_MUTATION,
              input: { uuid: subscription.uuid },
              id: subscription.id,
            })
          );
        }
      });
  }

  closePanel(): void {
    this.viewDetails = false;
    this.layoutService.closePanel();
  }
}
